/** @format */

import { CdkScrollable } from "@angular/cdk/scrolling";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { ToastService } from "mis-crystal-design-system/toast";
import { Observable, Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, filter, switchMap, takeUntil, tap } from "rxjs/operators";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { ConfigurationService } from "../../../services/configuration.service";
import { scrollDownFilter } from "../../../functions/custom-operators.functions";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { BookingDataService } from "../../../services/booking-data.service";
import { AsyncWidget } from "mis-crystal-design-system/widgets";

@Component({
  selector: "mis-employee-web-exp-list-card",
  templateUrl: "./list-card.component.html",
  styleUrls: ["./list-card.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListCardComponent implements OnInit, OnDestroy {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  @Input() list;
  @Input() emptyMessage: string;
  @Input() dateFormat;
  @Input() timeFormat;
  @Output() action = new EventEmitter(true);
  @Input() scrollToPaginate = false;
  @Input() showAll = false;
  private scrollObs: Subscription;
  xhrStatus: "DONE" | "LOADING" | "FAILED" = "DONE";
  @ViewChild(CdkScrollable, { static: false }) scrollContainer: CdkScrollable;
  @Input() widgetControl: AsyncWidget<NsEmpWebExpData.IList[]>;
  // @Input() filterOut: NsEmpWebExpData.IBookingDetailDTOS;
  expanded = false;
  listEnd = 3;

  constructor(
    public configSvc: ConfigurationService,
    private bookingSvc: BookingDataService,
    private cdr: ChangeDetectorRef,
    private toasts: ToastService
  ) {}

  ngOnInit(): void {
    this.listEnd = this.showAll ? 1000 : 3;
  }

  ngOnDestroy(): void {
    this.scrollObs?.unsubscribe();
  }

  cardAction(actId: number, widget: NsEmpWebExpData.IWidget): void {
    if (widget?.id === 2 && actId === 0) {
      widget.expanded = !widget.expanded;
      this.listEnd = widget.expanded ? 1000 : 3;
      this.cdr.detectChanges();
      // widget.expanded ? this.bookingSvc.expandUpcomingBookings() : this.bookingSvc.collapseUpcomingBookings();
      widget.actions.find(act => act.id === actId).name = widget.expanded ? "View less" : "View more";
    }
    // if (this.scrollToPaginate) this.updateScrollListeners(widget);
  }

  private updateScrollListeners(widget: NsEmpWebExpData.IWidget): void {
    this.scrollObs?.unsubscribe();
    if (widget.expanded) {
      this.scrollObs = this.scrollContainer
        ?.elementScrolled()
        .pipe(
          scrollDownFilter(this.scrollContainer),
          debounceTime(100),
          filter(val => {
            const offset = this.scrollContainer.measureScrollOffset("bottom");
            return this.xhrStatus !== "LOADING" && offset <= 200;
          }),
          switchMap(res => {
            this.bookingSvc.updateDates();
            this.xhrStatus = "LOADING";
            const obs = this.bookingSvc.genBookingRequest();
            return obs;
          })
        )
        .subscribe(
          res => {
            // this.bookingSvc.appendBookings(res?.data?.getEmployee?.[0]?.bookingDetailDTOS || []);
            // this.list = this.bookingSvc.upcomingBookings;
            this.xhrStatus = "DONE";
          },
          () => {
            this.xhrStatus = "FAILED";
            this.toasts.displayMsg("Unable to load future bookings!");
          }
        );
      // setTimeout(() => {}, 10);
    }
  }
}
